
import Swiper from 'vux/src/components/swiper/swiper.vue'

export default {
beforeCreate() {
document
.querySelector("body")
.setAttribute("style", "margin-bottom:30px;background-color:#d2e7e6");

document.querySelector("html").setAttribute("style", "height:100%");
},
data() {
return {
errorMsg: "",
showPositionValue: false,
activeId: "",
topImg: require("../assets/zhhlxh-logo.png"),
zsbmImg: require("../assets/zsbm.jpg"),
dhrcImg: require("../assets/01icon.png"),
zsjsImg: require("../assets/02icon.png"),
spzbImg: require("../assets/03icon.png"),
tpzbImg: require("../assets/04icon.png"),
logoImg: require("../assets/logo.png"),
proPdf: "",
zsList: [],
swipers: [
{
url: "/register",
img: require("../assets/show1.jpeg"),
title: "展商1"
},
{
url: "javascript:",
img: require("../assets/show2.jpeg"),
title: "展商2"
},
{
url: "javascript:",
img: require("../assets/show3.jpeg"),
title: "展商3"
}
]
};
},
async mounted() {
this.activeId = this.$route.params.id;
if (!this.activeId) {
this.activeId = this.$route.params.id;
}

this.queryInfo(this.activeId);
},
components: {
Swiper
},
methods: {
/**
* 跳转到展商列表
*
*/
toStores() {
this.$router.push({
name: "storelist",
params: { activeId: this.activeId }
});
},
/**
* 跳转大会日程pdf
*/
toProgramme() {
if (this.proPdf) {
this.$router.push({
name: "pdfView",
params: { activeId: this.activeId, pdfSrc: this.proPdf, pdfType: 'pro' }
});
} else {
this.showMsg("尚未上传大会日程");
}
},
/**
* 跳转到直播页面
*/
toLive(){
window.location.href = "http://live.zhhlxh.org.cn/video";
},
/**
* 获取提交信息
*
*/
async queryInfo(id) {
const getModel = this.$apis.exhibition.getMasterModel;
try {
const { data } = (await this.$axios.get(`${getModel}/${id}`)) || {};
if (!data) {

this.$router.push({ name: "error" });
}
/*   this.topImg = data.data.activePicUrl; */
this.swipers = [];
this.zsList = [{
url: "javascript:",
img: data.data.activePicUrl,
title: ""
}];
this.proPdf = data.data.proPdf;
for (var i = 0; i < data.showList.length; i++) {
var val = data.showList[i];
this.swipers.push({
url: "javascript:",
img: val.indexUrl,
title: val.storeName
});
}
} catch (err) {
this.showMsg(err||err.msg||err.data.msg);
}
},
/**
* 跳转注册页
*/
async toRegister() {

const tokenCheck = this.$apis.common.tokenCheck;
try {
const { data } = (await this.$axios.get(`${tokenCheck}/${this.activeId}`)) || {};
this.$router.push({
name: "info",
params: { id: data.id, cellPhone: data.cellPhone }
});
} catch (err) {
this.$router.push({
name: "loginSelect",
params: { activeId: this.activeId }
});
}
},
/**
* 显示提示信息
*
*/
showMsg(msg) {
this.errorMsg = msg;
this.showPositionValue = true;
},
autoSwap(item) {}
}
};



// WEBPACK FOOTER //
// ./src/components/index.vue